module.exports = new __parcel__URL__("SilverMiniPartnerBadge.static.873be33b.svg").toString();